import "Bacon";
import $ from "jquery";

var $body = $("body"),
  $container = $body.find('#notifications-container'),
  closeNotificationClickStream;

function createNotification(options) {
  var closeBtn = "<a href='#' class='close-notification'><span class='ea-icon ea-icon--cross'></span></a>";
  var $notification = $("<section class='notification'></section>").addClass(options.className).html(options.html);
  if (!options || options.showCloseIcon !== false) {
    $notification.append(closeBtn);
  }
  $notification.prependTo($container);
  toggleNotificationVisibilityClass();
}

function closeNotification($notification) {
  $notification.remove();
  toggleNotificationVisibilityClass();
}

function toggleNotificationVisibilityClass() {
  $body.toggleClass("notificationVisible", $("section.notification:visible").length > 0);
}

function setContentClassForTimePeriod($target, className, time) {
  $target.addClass(className);
  window.setTimeout(function () {
    $target.removeClass(className);
  }, time);
}

function getNotificationForEvent(event) {
  const $target = $(event.target);
  if ($target.hasClass('notification')) {
    return $target;
  }
  return $target.closest('.notification');
}

function isInternetExplorer() {
  const ua = window.navigator.userAgent;
  return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
}

closeNotificationClickStream = $body.asEventStream("click", ".notification .close-notification").map(getNotificationForEvent);
closeNotificationClickStream.onValue(closeNotification);

if (isInternetExplorer()) {
  createNotification({
    className: "error",
    html: 'Sinulla on käytössäsi vanha selain, joka ei tue Elisa Viihteen käyttöä. <a href="https://www.google.com/intl/fi_fi/chrome/" class="ea-notification__link">Lataa Google Chromen uusin versio</a>'
  });
}

export default {
  top: {
    create: createNotification,
    closeStream: closeNotificationClickStream
  },
  content: {
    setClassForTimePeriod: setContentClassForTimePeriod
  }
};



// WEBPACK FOOTER //
// ./web/js/notification.js